import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { getToken, setToken, clearToken } from '@/util/tokenManager';


interface AuthContextType {
  logged: boolean;
  login: () => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [logged, setLogged] = useState<boolean>(false);

  // 登录函数
  const login = () => {
    setLogged(true);
  };

  // 登出函数
  const logout = () => {
    console.log('AuthContext: Logout');
    setLogged(false);
    clearToken();
  };

  useEffect(() => {
    // 检查 URL 参数中是否有 t
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get('t');

    if (tokenFromUrl) {
      // 设置token到localStorage
      setToken(tokenFromUrl);
      console.log('AuthContext: Setting new token from URL', tokenFromUrl);

      // 验证token是否设置成功
      setTimeout(() => {
        const verifyToken = getToken();
        console.log('AuthContext: Token verification after set:', verifyToken || 'FAILED');
      }, 100);

      login();

      // 从 URL 中移除 t 参数
      urlParams.delete('t');
      const newUrl = urlParams.toString()
        ? `${window.location.pathname}?${urlParams.toString()}`
        : window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    } else {
      // 如果 URL 中没有 t 参数，检查localStorage
      const accessToken = getToken();
      if (accessToken) {
        setLogged(true);
      }
    }
  }, []);

  return (
    <AuthContext.Provider value={{ logged, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

